import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { Navigation } from "swiper/modules";
import axios from "axios";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

// const data = [
//   {
//     contentType: "Company Profile",
//     title: "Know more about our business solutions.",
//     description: "",
//     thumbnail:
//       "/images/press/1.jpg",
//     link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
//     linkText: "Download Profile",
//     linkType: "file",
//     readTime: 10,
//   },
//   {
//     contentType: "Media and PR Guide",
//     title: "The story we’re ready to share with the world!",
//     description: "",
//     thumbnail:
//       "/images/press/2.png",
//     link: "/newsroom",
//     linkText: "Launch Newsroom",
//     linkType: "website",
//     readTime: 15,
//   },
//   {
//     contentType: "Events",
//     title: "Catch us at the top conferences and expos—let’s connect!",
//     description: "",
//     thumbnail:
//       "/images/press/3.jpeg",
//     link: "#",
//     linkText: "Register for Event",
//     linkType: "website",
//     readTime: 20,
//   },
//   {
//     contentType: "Whitepapers",
//     title: "Unlock valuable insights with our expert whitepapers!",
//     description: "",
//     thumbnail:
//       "/images/press/4.jpeg",
//     link: "#",
//     linkText: "View",
//     linkType: "website",
//     readTime: 25,
//   },
// ];

export default function CardSlider({title}) {
  const { height, width } = useWindowDimensions();
  const [slidesPerView, setSlidesPerView] = useState(1);
  const [data, setData] = useState([]);

  const fetchResources = async () => {
    try {
      const res = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/insights/resources`);
      if (res.status === 200) {
        // console.log("Resources: ", res?.data);
        setData(res?.data);
      }
    } catch (error) {
      console.error("Error fetching resources: ", error);
    }
  }

  useEffect(()=> {
    fetchResources();
  }, []);

  const swiperRef = useRef(null);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.swiper.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.swiper.slideNext();
  };

  useEffect(() => {
    if (width >= 320 && width < 480) {
      setSlidesPerView(1);
    } else if (width >= 480 && width < 600) {
      setSlidesPerView(2);
    } else if (width >= 600 && width < 1080) {
      setSlidesPerView(3);
    } else if (width >= 1080 && width < 2200) {
      setSlidesPerView(4);
    } else if (width >= 2200) {
      setSlidesPerView(6);
    } else {
      setSlidesPerView("auto");
    }
  }, [width]);
  return (
    <>
      <div className="stories-header mb-4">
        <h2>{title || "Discover Our Resources"}</h2>
        <div className="section-nav">
          <div className="left-btn">
            <button className="nav-btn" onClick={handlePrev}>
              <i class="fa-solid fa-arrow-left"></i>
            </button>
          </div>
          <div className="right-btn">
            <button className="nav-btn" onClick={handleNext}>
              <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <Swiper
      ref={swiperRef}
        spaceBetween={30}
        slidesPerView={slidesPerView}
        modules={[Navigation]}
        className="swiper-container"
      >
        {Array.isArray(data) && data?.length &&
          data?.map((item, index) => (
            <SwiperSlide className="resource-card" key={index}>
              <img src={item?.imgsrc} alt={item?.title} />
              <div className="card-content">
                <div className="resource-content">
                  <div className="resource-caption">{item?.title}</div>
                  <div className="resource-title">{item?.headline}</div>
                </div>
                <div className="resource-action">
                  <Link to={item?.resourceType ? item?.fileUrl : item?.link}>
                    {item?.linkText}{" "}
                    <i
                      class={`fa-solid ${
                        item?.linkType === "file"
                          ? "fa-download"
                          : item?.linkType === "website"
                          ? "fa-arrow-up-right-from-square"
                          : "fa-arrow-up-right-from-square"
                      }`}
                    ></i>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </>
  );
}
